export enum LayoutTestIds {
  AbiFooter = 'abi-footer',
  FallbackText = 'fallback-text',
  GlobalLoadingIndicator = 'global-loading-indicator',
  OfflineIndicator = 'offline-indicator',
  PrintButton = 'print-button',
  SidebarDrawer = 'sidebar-drawer',
  SidebarDrawerCloseButton = 'sidebar-drawer-button-collapsed',
  PermissionsModal = 'permissions-modal',
  NotificationsModal = 'notifications-modal',
  ShowPermissionsButton = 'show-permissions-button',
  ShowNotificationsButton = 'show-notifications-button',
  UserProfileButton = 'user-profile-button',
  BrewerySelectionSearchBar = 'brewery-selection-search-bar',
  HelpMenuButton = 'help-menu-button',
  ConfirmChangesModalSaveButton = 'confirm-changes-modal-save-button'
}
